export default {
    everyText: 'Mỗi',
    periodLabel: 'Thời hạn',
    atEveryText: 'Vào lúc / Mỗi',
    minuteLabel: 'Phút',
    atOptionLabel: 'Vào lúc',
    everyOptionLabel: 'Mỗi',
    betweenText: 'Từ',
    inText: 'Trong',
    onText: 'Vào thứ',
    andText: 'đến',
    monthLabel: 'Tháng',
    dayOfWeekLabel: 'Thứ trong tuần',
    onEveryText: 'Vào ngày/Mỗi',
    multiDayOfMonthLabel: 'Ngày trong tháng',
    dayOfMonthLabel: 'Ngày',
    hourLabel: 'Giờ',
    weekDaysOptions: [
      'CHỦ NHẬT',
      'THỨ HAI',
      'THỨ BA',
      'THỨ TƯ',
      'THỨ NĂM',
      'THỨ SÁU',
      'THỨ BẢY',
    ],
    periodOptions: ['Giờ', 'Ngày', 'Tuần', 'Tháng', 'Năm'],
    shortMonthOptions: [
      'Tháng 1',
      'Tháng 2',
      'Tháng 3',
      'Tháng 4',
      'Tháng 5',
      'Tháng 6',
      'Tháng 7',
      'Tháng 8',
      'Tháng 9',
      'Tháng 10',
      'Tháng 11',
      'Tháng 12',
    ],
    onOptionLabel: 'Vào lúc',
    lastDayOfMonthLabel: 'Ngày cuối tháng',
    cronDescriptionText: 'vi',
}